import { BackgroundThemeRevision } from 'referral-types';
import { useColorStyles } from '../../../../hooks/useColorStyles';

import './_styles.scss';

export enum StripeSubThemeIds {
  plaid = 'plaid',
  plaidDark = 'plaid-dark',
  plaidAlt = 'plaid-alt',
  plaidAltDark = 'plaid-alt-dark',
  verticalStripes = 'vertical-stripes',
  diagonalStripes = 'diagonal-stripes',
  diagonalStripesAlt = 'diagonal-stripes-alt',
}

export const StripeSubThemeOptions = [
  { value: StripeSubThemeIds.plaid, label: 'Plaid' },
  { value: StripeSubThemeIds.plaidDark, label: 'Plaid Dark' },
  { value: StripeSubThemeIds.plaidAlt, label: 'Plaid Alt' },
  { value: StripeSubThemeIds.plaidAltDark, label: 'Plaid Alt Dark' },
  { value: StripeSubThemeIds.verticalStripes, label: 'Vertical Stripes' },
  { value: StripeSubThemeIds.diagonalStripes, label: 'Diagonal Stripes' },
  { value: StripeSubThemeIds.diagonalStripesAlt, label: 'Diagonal Stripes Alt' },
];

export const StripesBackground: React.FC<{ themeRevision?: Partial<BackgroundThemeRevision> }> = (props) => {
  const { themeRevision } = props;
  const pattern = themeRevision?.subTheme || 'none';

  const colorStyles1 = useColorStyles(themeRevision?.colorId1);
  const colorStyles2 = useColorStyles(themeRevision?.colorId2);
  const backgroundColor1 = colorStyles1.background;
  const backgroundColor2 = colorStyles2.background;

  return (
    <div className={`relative -z-10 h-full w-full bg-green-500 ${backgroundColor1}`}>
      {/* THE PATTERN LAYER 
        - 'absolute inset-0': Stretches to fill container
        - 'pointer-events-none': Lets clicks pass through to content
        - 'pattern-${pattern}': Applies the mask class from your config
      */}
      <div className={`pointer-events-none absolute inset-0 ${pattern}`} />
    </div>
  );
};
